import React from 'react';

const WhatsAppButton = ({ phone }) => {
    return (
        <a
            href={`https://wa.me/${phone}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                position: 'fixed',
                bottom: '90px',
                right: '30px',
                backgroundColor: '#25D366',
                color: 'white',
                borderRadius: '90%',
                width: '55px',
                height: '55px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                zIndex: 1000,
                cursor: 'pointer',
                fontSize: '30px'
            }}
        >
            <i className="fab fa-whatsapp"></i>
        </a>
    );
};

export default WhatsAppButton;
